import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrioridadesService {

  constructor(private http:HttpClient) { }

  public async prioridades(){
    return await this.http.get(`${environment.api}prioridades`).toPromise();
  }

}
